import * as THREE from "three";
import { HDRCubeTextureLoader } from "./extra/HDRCubeTextureLoader";
import { PMREMGenerator } from "./extra/PMREMGenerator";
import { PMREMCubeUVPacker } from "./extra/PMREMCubeUVPacker";
import { OBJLoader } from "./extra/ObjLoader";
import { BufferGeometry } from "three";
import * as dat from "dat.gui";
import * as player from "./player";

// REQUIRED STUFF

let scene = new THREE.Scene();
let camera = new THREE.PerspectiveCamera(10, window.innerWidth/window.innerHeight, 1, 1000);
camera.position.z += 500;
let renderer = new THREE.WebGLRenderer({ alpha: true });
renderer.setSize(window.innerWidth, window.innerHeight);

document.body.appendChild(renderer.domElement);
let img = document.querySelector("img");

// NON REQUIRED STUFF

var manager = new THREE.LoadingManager();
manager.onProgress = function ( item, loaded, total ) {
    console.log( item, loaded, total );
};

let light = new THREE.AmbientLight(0xffffff);
scene.add(light);

var loader = new THREE.CubeTextureLoader();
loader.setPath( 'cube-bw/' );

var textureCube = loader.load( [
	'px.png', 'nx.png',
	'py.png', 'ny.png',
	'pz.png', 'nz.png'
] );
textureCube.magFilter
textureCube.format = THREE.RGBFormat;

var front = new THREE.MeshLambertMaterial( { color: 0xffffff, envMap: textureCube, refractionRatio: 0.1, side: THREE.FrontSide, opacity: 0.5 } );
var back = new THREE.MeshLambertMaterial( { color: 0xffffff, envMap: textureCube, refractionRatio: 0.1, side: THREE.BackSide, opacity: 0.2 } );

let objects: THREE.Group[] = [];

// GUI

interface Settings {
    numMirrors: number,
    backFaceOpacity: number,
    frontFaceOpacity: number,
    mirrorSize: number,
    spacing: number,
}

let settings = {
    numMirrors: 31,
    spacing: 41,
    backFaceOpacity: 0.2,
    frontFaceOpacity: 0.5,
    mirrorSize: 28,
};

addMirrors(settings);

function update() {
    removeMirrors();
    addMirrors(settings);
}

function addMirrors(settings: Settings) {
    let size = settings.mirrorSize;
    let spacing = settings.spacing;
    
    for (var i = 0; i < settings.numMirrors; i++) {
        var geometry = new THREE.Geometry();
        geometry.vertices.push(
            new THREE.Vector3( Math.random() * size - size/2, Math.random() * size - size/2, Math.random() * size - size/2 ),
            new THREE.Vector3( Math.random() * size - size/2, Math.random() * size - size/2, Math.random() * size - size/2 ),
            new THREE.Vector3( Math.random() * size - size/2, Math.random() * size - size/2, Math.random() * size - size/2 )
        );
        geometry.faces.push( new THREE.Face3( 0, 1, 2 ) );
        geometry.computeBoundingSphere();
        geometry.computeFaceNormals();
        let fmesh = new THREE.Mesh(geometry, front);
        let bmesh = new THREE.Mesh(geometry, back);
        let g = new THREE.Group();
        g.position.x += Math.random() * spacing - spacing/2;
        g.position.y += Math.random() * spacing - spacing/2;
        g.add(fmesh);
        g.add(bmesh);
        scene.add(g);
    
        objects.push(g);
    }
}

function removeMirrors() {
    // Delete all old ones
    objects.forEach(obj => {
        obj.children.forEach(o => obj.remove(o));
        scene.remove(obj);
    });
}

// var gui = new dat.GUI();
// gui.add(settings, 'numMirrors', 1, 50).onFinishChange(update);
// gui.add(settings, 'mirrorSize', 5, 60).onFinishChange(update);
// gui.add(settings, 'spacing', 5, 60).onFinishChange(update);
// gui.add(front, 'opacity', 0, 1).name("Front face opacity");
// gui.add(back, 'opacity', 0, 1).name("Back face opacity");

// REQUIRED BUT RUN AT END

let rotateSpeed = {x: 0.01, y: 0.005};
let rotateSpeedMultiplier = {x: 1, y: 1};
window["rotateSpeedMultiplier"] = rotateSpeedMultiplier;

function animate() {
    requestAnimationFrame( animate );
    objects.forEach(child => {
        child.rotateX(rotateSpeed.x * rotateSpeedMultiplier.x);
        child.rotateY(rotateSpeed.y * rotateSpeedMultiplier.y);
    })
    
    renderer.render(scene, camera);
}

animate();

document.addEventListener('DOMContentLoaded', () => {
    player.setup();
}, false);
